// removed by extract-text-webpack-plugin
module.exports = {"root":"_2gYS3","plans":"_ggnvl","featureList":"_3sJaM","listItem":"_1COiA","check":"_3TH4a","text":"_y9Tkr","planGroups":"_3UE5D","highlight":"_xwawM","name":"_3LYPv","price":"_1eqGn","plan":"_2glLQ","carousel":"_3JNR2"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/LiveSection/LiveSection.scss
// module id = 1336
// module chunks = 3